export default 'M17.17 21H21L16.73 3h-4.27L3 21h4.14l2.02-4.11h7.18zm-6.44-7.3 3.46-7.1 1.47 7.1z';